<div (window:resize)="debouncedOnResize()" [hidden]="!showButton"
     [ngStyle]="{
     'left': calculatedPosition?.x + '%',
     'top':  calculatedPosition?.y+'%',
     'z-index': readspeakerElement?.zIndex,
     'transform': transform,
      '-webkit-transform': transform,
       '-ms-transform': transform }"
     class="readspeaker-element">

    @if (showButton) {
        <div [attr.id]="'readspeaker_button' + eleId" class="rs_skip rsbtn rs_preserve grow">
            <a accesskey="L" class="rsbtn_play" href="{{ link }}" rel="nofollow"
               title="Text vorlesen">
                <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span>Vorlesen</span></span></span>
                <span class="rsbtn_right rsimg rsplay rspart"></span>
            </a>
        </div>
    }

</div>


